import styled from 'styled-components/macro';
import Select from 'react-select';
import { getSelectAnimation } from 'styles/animations.styled';

export const Wrapper = styled.div<{
  collapsed: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 12px;
  animation-name: ${(props) => getSelectAnimation(props.collapsed)};
  animation-delay: 0s;
  animation-duration: 300ms;
  transition: 150ms all;
`;

export const StyledSelect = styled(Select)<{
  collapsed: boolean;
}>`
  width: 100%;

  .other__control {
    border: 1px solid #ced5de;
    animation-name: ${(props) => getSelectAnimation(props.collapsed)};
    animation-delay: 0s;
    animation-duration: 300ms;
    transition: 150ms all;
  }
`;
